import { fork } from 'redux-saga/effects';

import AuthGateway from '~apis/auth';
import AdminGateway from '~apis/admin';
import { RootSagaReturnType } from '~types/saga';

import watchLogin from './login';
import watchStartup from './startup';
import watchLogout from './logout';
import watchGetUserDetails from './getUserDetails';
import watchGetIsMarketOpen from './getIsMarketOpen';

export default (api: AuthGateway, adminApi: AdminGateway): RootSagaReturnType => {
    function* rootSaga() {
        yield fork(watchLogin, api);
        yield fork(watchStartup);
        yield fork(watchLogout, api);
        yield fork(watchGetUserDetails, adminApi);
        yield fork(watchGetIsMarketOpen, adminApi);
    }

    return {
        rootSaga,
    };
};
